module.exports = __webpack_public_path__ + "static/media/lobo-genetics-card-logo.f8cbc99c.png";